import React from 'react';
import './LicenseRegister.css';

const LicenseRegister = () => {
  return (
      <main className='main'>
          <section className='section'>
              <div className="license-register-container container">
                  <div className='player-support-article'>
                      <h1 className='section-title'>License Register</h1>


                      <article>
                          <p>
                              Welcome to the official License Register of Anjouan Gaming. As the sole authorized license
                              administrator for the autonomous island of Anjouan, we take pride in offering transparency
                              and
                              ensuring the highest standards of integrity in the online gaming industry.
                          </p>
                      </article>
                      <article>
                          <h2 className='section-subtitle'>About Our License Register</h2>
                          <p>
                              The License Register provides a comprehensive, up-to-date list of all gaming operators
                              licensed
                              under the Anjouan Gaming authority. Each licensee listed here has undergone our rigorous
                              vetting
                              process, ensuring compliance with Anjouan’s strict regulatory standards. This register is
                              part
                              of
                              our commitment to maintaining a fair, safe, and transparent gaming environment for all
                              players. If
                              an operator claiming to be licensed does not appear here then they are not a license
                              holder in
                              good standing and should be avoided.
                          </p>
                      </article>
                      <article>
                          <h2 className='section-subtitle'>What You’ll Find</h2>
                          <ul>
                              <li><strong>Licensee Name:</strong> The official name of the licensed gaming operator.
                              </li>
                              <li><strong>License Number:</strong> A unique identifier assigned to each licensed
                                  operator.
                              </li>
                              <li><strong>Date of Expiration:</strong> The date on which the license was granted.</li>
                              <li><strong>Status:</strong> Current standing of the license, indicating whether it is
                                  active,
                                  suspended, or revoked.
                              </li>
                              <li><strong>Authorized Activities:</strong> A summary of the gaming activities that the
                                  licensee
                                  is permitted to conduct under their license.
                              </li>
                              <li><strong>Authorized URLs:</strong> A list of all URLs authorized on their license.</li>
                          </ul>
                      </article>
                      <article>
                          <h2 className='section-subtitle'>How to Use the Register</h2>
                          <p>
                              To verify the legitimacy of a gaming operator, simply search for their name or license
                              number
                              in
                              the register. You can also browse the full list of our licensees to learn more about the
                              diverse
                              operators who have chosen to be regulated by Anjouan Gaming.
                          </p>
                      </article>

                      <article>
                          <h2 className='section-subtitle'>Why Choose an Anjouan Gaming Licensed Operator?</h2>
                          <p>
                              Operators licensed by Anjouan Gaming are recognized for their commitment to player safety,
                              fair
                              play, and responsible gaming. Our licensing process is designed to protect players by
                              ensuring
                              that all licensed operators adhere to the highest standards of operational excellence and
                              ethical
                              conduct.
                          </p>
                      </article>
                      <article>
                          <h2 className='section-subtitle'>Contact Us</h2>
                          <p>
                              If you have any questions or need assistance with the License Register, please contact our
                              support
                              team. We’re here to help ensure you have a safe and enjoyable gaming experience.
                          </p>

                      </article>

                      <article>
                          <h2 className='section-subtitle'>Register of License Holders in Good Standing</h2>
                          <p>
                              The following list of License Holders and their URL’s have been certified by Anjouan
                              Gaming.
                              Please note, not all URL’s are available in all jurisdictions. For further information
                              consult
                              the
                              specific URL’s Terms & Conditions. Updated May 20 2025.
                          </p>
                      </article>
                  </div>
              </div>
          </section>
      </main>
  );
};

export default LicenseRegister;